module.exports = __webpack_public_path__ + "static/img/share.ba86c24.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2/11/share.jpg
// module id = Pyru
// module chunks = 27